import React from 'react';
import HomeGrid from '../components/HomeGrid'
import '../style.css';

export default function Home() {
  return (
    <div class="content load-first">
        <h2>Journalist, Analyst, Designer</h2>
        <p>I'm Nina Moothedath, a graduate student at the University of Southern California pursuing a M.S. in Communication Data Science after completing a B.A. in Journalism. You can explore the different work I do below!</p>

        <div class="home-grid load-second">
          <HomeGrid name="cd" text="Data Reporting & Graphics"/>

          <HomeGrid name="graphics" text="Art & Broadcast Graphics"/>

          <HomeGrid name="va" text="Multimedia Production"/>

          <HomeGrid name="about" text="About"/>

        </div>

      </div>
  );
}
